/**
 * @author Kishan Virani
 * @email Kishan@Zezamii.com
 * @create date 14-01-2022  14:31:04
 * @modify date 11-08-2022  17:05:23
 * @desc [description]
 */

import basicStyle from 'assets/styles/constants';
import { getDownloadURL } from 'library/firebase/fb.utils';
import React, { useEffect, useState } from 'react';
import { GoogleMaps, LeafletMap, Loader, Notification, UploadMapComponent } from 'zComponents/atoms';
import { Col, Layout, Row } from 'zui/Antd';

const HybridMap = ({ data, mapType }) => {
	useEffect(() => {
		if (!mapType) Notification('error', 'Please provide correct MapType Props');
	}, [mapType]);

	const [map, setMap] = useState(null);
	const [pending, setPending] = useState(true);

	const { rowStyle, colStyle, loadingStyle } = basicStyle;

	useEffect(() => {
		const loadFloorPlan = async () => {
			setPending(true);
			if (data.url && data.url.toString().toLowerCase() !== 'n/a') {
				await getDownloadURL(data.url)
					.then((url) => setMap(url))
					.then(() => setPending(false));
			} else if (data.latitude && data.longitude) {
				setPending(false);
			}
		};
		loadFloorPlan();
	}, [data.url, data.latitude, data.longitude]);

	return (
		<Layout
			style={{
				height: '100%',
				alignContent: 'center',
				position: 'relative'
			}}
		>
			{pending ? (
				<Loader style={{ position: 'relative', width: 100 }} />
			) : data.url && data.url.toString().toLowerCase() !== 'n/a' ? (
				<LeafletMap
					mapHeight={460}
					mapWidth={800}
					scrollWheelZoom={true}
					url={map}
					markerList={data.markerList}
				>
					<UploadMapComponent data={data} mapType={mapType} buttonLabel={'Update Plan'} />
				</LeafletMap>
			) : data.latitude && data.longitude ? (
				<GoogleMaps data={data}>
					<UploadMapComponent data={data} mapType={mapType} buttonLabel={'Update Site Location'} />
				</GoogleMaps>
			) : (
				<Row style={(rowStyle, { height: '100%', alignContent: 'center' })} gutter={0} justify='space-around'>
					<Col lg={24} md={24} sm={24} xs={24} style={colStyle}>
						<div style={loadingStyle}>
							Map Loading Error. Please check your internet connection and try again.
						</div>
					</Col>
				</Row>
			)}
		</Layout>
	);
};
export default HybridMap;
